import serviceOrder from '@/api/report/service-order'
import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  serviceRequest(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
      },
      attributes
    )
    return serviceOrder.serviceRequest({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  // generate monthly sale item as excel
  serviceRequestExportExcel(context, payload) {
    return serviceOrder.serviceRequestExportExcel(payload)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await serviceOrder.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },

}
